import {
  GET_TRUCK_TIRES,
  GET_TRUCK_TIRE,
  GET_TRUCK_TIRE_CATEGORIES,
  GET_TRUCK_TIRE_BRANDS,
  CREATE_TRUCK_TIRE,
  UPDATE_TRUCK_TIRE,
  DELETE_TRUCK_TIRE,
  SET_TRUCK_TIRE_LOADING,
  SET_TRUCK_TIRE_ERROR
} from '../actions/truckTire';

import { TruckTire, TruckTireCategory, TruckTireBrand, TruckTirePagination } from '../../services/truckTireService';

export interface TruckTireState {
  truckTires: TruckTire[];
  currentTruckTire: TruckTire | null;
  categories: TruckTireCategory[];
  brands: TruckTireBrand[];
  pagination: TruckTirePagination | null;
  loading: boolean;
  error: string | null;
}

const initialState: TruckTireState = {
  truckTires: [],
  currentTruckTire: null,
  categories: [],
  brands: [],
  pagination: null,
  loading: false,
  error: null
};

const truckTireReducer = (state = initialState, action: any): TruckTireState => {
  switch (action.type) {
    case GET_TRUCK_TIRES:
      return {
        ...state,
        truckTires: action.payload.truckTires,
        pagination: action.payload.pagination,
        error: null
      };

    case GET_TRUCK_TIRE:
      return {
        ...state,
        currentTruckTire: action.payload,
        error: null
      };

    case GET_TRUCK_TIRE_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        error: null
      };

    case GET_TRUCK_TIRE_BRANDS:
      return {
        ...state,
        brands: action.payload,
        error: null
      };

    case CREATE_TRUCK_TIRE:
      return {
        ...state,
        truckTires: [action.payload, ...state.truckTires],
        error: null
      };

    case UPDATE_TRUCK_TIRE:
      return {
        ...state,
        truckTires: state.truckTires.map(tire => 
          tire._id === action.payload._id ? action.payload : tire
        ),
        currentTruckTire: state.currentTruckTire?._id === action.payload._id 
          ? action.payload 
          : state.currentTruckTire,
        error: null
      };

    case DELETE_TRUCK_TIRE:
      return {
        ...state,
        truckTires: state.truckTires.filter(tire => 
          tire._id !== action.payload && tire.UrunID !== action.payload
        ),
        currentTruckTire: state.currentTruckTire?._id === action.payload ||
                          state.currentTruckTire?.UrunID === action.payload
          ? null 
          : state.currentTruckTire,
        error: null
      };

    case SET_TRUCK_TIRE_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case SET_TRUCK_TIRE_ERROR:
      return {
        ...state,
        error: action.payload
      };

    default:
      return state;
  }
};

export default truckTireReducer;
